import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "../Molecules"
import { FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { IlloPartners } from "../../atoms/Illustrations"
import { Body } from "../../atoms/Bodies"
import React, { useLayoutEffect } from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"
import { Button } from "../../atoms/buttons/Button"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import useAboutYou from "../hooks/useAboutYou"
import { useHistory } from "react-router"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerIntro = ({ next, skip, previous }) => {
  const history = useHistory()
  const { goBack, wentBack, onFlowComplete } = useAboutYouFlowControls()
  const { data, updateAboutYou, hasQuestionBeenSkipped, continueLoading } = useAboutYou()

  const nullOutPartnerInfo = async () => {
    await updateAboutYou({
      partnerFirstName: "nullOut",
      partnerLastName: "nullOut",
      partnerEmail: "nullOut",
      partnerDateOfBirth: "nullOut",
      partnerGenderIdentityOther: "nullOut",
      partnerPreferredName: "nullOut",
      partnerSex: "nullOut",
      partnerGenderIdentity: "nullOut",
      partnerSection: "skip"
    })
  }

  useLayoutEffect(() => {
    if (!wentBack) {
      if (hasQuestionBeenSkipped("partnerSection")) {
        onFlowComplete()
        history.push(skip)
      }
      if (data?.partnerFirstName) {
        history.push(next)
      }
    }
  }, [hasQuestionBeenSkipped, history, next, onFlowComplete, wentBack])

  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <ContinueArrow
            to={Boolean(data?.partnerFirstName) ? next : skip}
            enabled={(Boolean(data?.partnerFirstName) || hasQuestionBeenSkipped("partnerSection")) && !continueLoading}
          />
        </FleContinueWrapper>
      }
    >
      <AboutYouTopSection previous={previous}>
        <TopSection progressStep={3} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
      </AboutYouTopSection>
      <FlexRowCenter>
        <IlloPartners />
      </FlexRowCenter>
      <SpacerSwitcher />
      <SwitchH1ToH2>{l`Are you on your family-forming journey with a partner?`}</SwitchH1ToH2>
      <Spacer height={1} />
      <Body color="black-80">
        {l`Providing details about your partner or spouse helps us better support both of you.`}
      </Body>
      <div key={"Yes"} className="flex flex-row justify-end w-100 mb1">
        <Button outline={Boolean(data?.partnerFirstName)} bold={false} to={next} onClick={onFlowComplete}>
          Yes
        </Button>
      </div>
      <div key={"No"} className="flex flex-row justify-end w-100 mb1">
        <Button
          outline={hasQuestionBeenSkipped("partnerSection")}
          bold={false}
          to={skip}
          onClick={() => {
            onFlowComplete()
            nullOutPartnerInfo()
          }}
        >
          No
        </Button>
      </div>
    </FleLayout>
  )
}

export { AboutYourPartnerIntro }
